// removed by extract-text-webpack-plugin
module.exports = {"content":"_1Lz7Up3p3","grid":"fj7572pM6 _2hnOWLuze _3ugGu5boG"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/grid/grid-content/grid-content.css
 ** module id = 2127
 ** module chunks = 0
 **/